export const copy = {
  fi: {
    nav: {
      services: "Palvelut",
      work: "Projektit",
      cases: "Case",
      contact: "Yhteys",
      menu: "Avaa valikko",
      close: "Sulje valikko",
      home: "PK-Forensics etusivulle",
      language: "Valitse kieli",
    },
    hero: {
      eyebrow: "Sovelluskehitys / Digitaalinen tutkinta",
      title: ["Ideasta", "toimivaksi", "tuotteeksi."],
      lead: "Toteutan pieniä ja selkeästi rajattuja digitaalisia ratkaisuja yksityishenkilöille, seuroille ja yrityksille — käytännön tarpeesta toimivaksi työkaluksi.",
      primary: "Tutustu projekteihin",
      secondary: "Keskustele ideasta",
      scroll: "Vieritä tutustuaksesi",
      visualLabel: "Tuotekehitys",
      visualTitle: "Selkeä suunta.\nToimiva toteutus.",
      visualMeta: "Android · Web · Desktop",
    },
    intro: {
      label: "Kenelle",
      title: "Sama palvelu, kaiken kokoisiin tarpeisiin.",
      body: "PK-Forensics on yhden tekijän ketterä palvelu. Autan silloin, kun tarvitset rajatun sovelluksen, digitaalisen työkalun tai selkeän teknisen ratkaisun ilman raskasta projektia.",
      values: [
        ["01", "Yksityishenkilöt", "Ideasta voi syntyä pieni sovellus, hyödyllinen laskuri tai omaan arkeen sopiva digitaalinen apuri."],
        ["02", "Seurat ja yhteisöt", "Kevyet työkalut voivat helpottaa viestintää, seurantaa, harjoittelua tai yhteistä toimintaa."],
        ["03", "Yritykset", "Rajatut sovellukset ja apuvälineet tukevat yksittäistä prosessia ilman raskasta järjestelmähanketta."],
      ],
    },
    service: {
      label: "Palvelu",
      title: "Sovelluskehitys",
      lead: "Kevyt ja hallittu tapa muuttaa rajattu idea käyttökelpoiseksi digitaaliseksi ratkaisuksi.",
      description: "Toteutan pieniä mobiili-, web- ja työpöytäsovelluksia sekä käytännöllisiä analytiikkatyökaluja. Jokainen työ rajataan selkeäksi kokonaisuudeksi, jonka yksi tekijä voi toteuttaa laadukkaasti.",
      platforms: ["Android", "Kevyet web-työkalut", "Desktop-apurit", "Data ja visualisointi"],
      stages: [
        ["01", "Tarve", "Käydään läpi, mikä pieni tai rajattu ongelma halutaan ratkaista."],
        ["02", "Rajaus", "Valitaan tärkeimmät toiminnot ja pidetään kokonaisuus hallittavana."],
        ["03", "Toteutus", "Ratkaisu rakennetaan vaiheittain ja toimivuus varmistetaan käytännössä."],
        ["04", "Käyttöönotto", "Valmis työkalu viimeistellään sovittuun käyttöön."],
      ],
      cta: "Kerro tarpeestasi",
      emailSubject: "Yhteydenotto PK-Forensicsille",
    },
    work: {
      label: "Valitut projektit",
      title: "Ratkaisuja oikeisiin tilanteisiin.",
      body: "Esimerkkejä projekteista",
      open: "Avaa projekti",
      all: "Kaikki projektit",
    },
    cases: {
      label: "Forensics lab",
      title: "Data kertoo, kun sen tekee näkyväksi.",
      body: "ByBit Hack -analyysi näyttää, kuinka monimutkainen siirtoketju voidaan purkaa ymmärrettävään ja visuaaliseen muotoon.",
      open: "Tutustu caseen",
    },
    cta: {
      label: "Onko sinulla idea?",
      title: "Tehdään siitä toimiva.",
      body: "Olitpa yksityishenkilö, seura tai yritys, kerro pienestä ideasta tai rajatusta tarpeesta, johon etsit käytännöllistä ratkaisua.",
      button: "Ota yhteyttä",
    },
    contactDialog: {
      label: "Yhteydenotto",
      title: "Ota yhteyttä",
      body: "Valitse käyttämäsi sähköpostipalvelu. Uusi viesti avautuu valmiiksi osoitteeseen jarmo@pk-forensics.fi.",
      subject: "Yhteydenotto PK-Forensicsille",
      gmail: "Avaa Gmail",
      outlook: "Avaa Outlook",
      copy: "Kopioi sähköpostiosoite",
      copied: "Sähköpostiosoite kopioitu",
      close: "Sulje",
    },
    footer: {
      statement: "Yhden tekijän käytännönläheistä sovelluskehitystä ja digitaalista tutkintaa kaikille.",
      navigation: "Navigaatio",
      contact: "Yhteys",
      businessId: "Y-tunnus 2937386-3",
      privacy: "Tietosuojaseloste",
      ytVidPrivacy: "YTVidCreatorin tietosuoja",
      rights: "Kaikki oikeudet pidätetään.",
    },
    privacy: {
      title: "Tietosuojaseloste",
      updated: "Päivitetty 22.4.2025",
      intro: "PK-Forensics käsittelee yhteydenottojen yhteydessä annettuja tietoja luottamuksellisesti ja vain asioinnin edellyttämässä laajuudessa.",
      sections: [
        ["Rekisterinpitäjä", "PK-Forensics, Y-tunnus 2937386-3, Suomi. Yhteys: jarmo@pk-forensics.fi, +358 50 327 9741."],
        ["Kerättävät tiedot", "Nimi ja yhteystiedot, viestien sisältö sekä mahdolliseen asiakas- ja laskutussuhteeseen tarvittavat tiedot."],
        ["Käsittelyn tarkoitus", "Yhteydenottoihin vastaaminen, palveluiden toimittaminen, tarjousten ja sopimusten valmistelu, laskutus, kirjanpito sekä palveluiden turvallisuus."],
        ["Säilytys", "Yhteydenottoviestejä säilytetään enintään 30 päivää viimeisestä yhteydenotosta, ellei asiakassuhdetta synny. Kirjanpitotiedot säilytetään lain edellyttämän ajan."],
        ["Tietojen luovutus", "Tietoja ei luovuteta kolmansille osapuolille ilman suostumusta tai lain velvoitetta, eikä niitä siirretä EU/ETA-alueen ulkopuolelle."],
        ["Oikeutesi", "Sinulla on oikeus tarkastaa, oikaista tai pyytää poistamaan tietosi, rajoittaa tai vastustaa käsittelyä sekä käyttää muita tietosuojalainsäädännön mukaisia oikeuksiasi."],
      ],
      close: "Sulje",
    },
    detail: {
      back: "Takaisin projekteihin",
      overview: "Yleiskuva",
      focus: "Projektin fokus",
      gallery: "Projektin näkymiä",
      viewGraph: "Avaa interaktiivinen 3D-mallinnus",
      store: "Avaa Google Playssa",
      next: "Seuraava projekti",
      notFound: "Projektia ei löytynyt",
      notFoundBody: "Etsimääsi projektisivua ei ole olemassa.",
      home: "Palaa etusivulle",
    },
  },
  en: {
    nav: {
      services: "Services",
      work: "Projects",
      cases: "Case",
      contact: "Contact",
      menu: "Open menu",
      close: "Close menu",
      home: "PK-Forensics home",
      language: "Select language",
    },
    hero: {
      eyebrow: "App development / Digital forensics",
      title: ["From idea", "to a product", "that works."],
      lead: "I build small, clearly scoped digital solutions for individuals, clubs and companies — turning a practical need into a useful tool.",
      primary: "Explore the projects",
      secondary: "Discuss your idea",
      scroll: "Scroll to explore",
      visualLabel: "Product development",
      visualTitle: "Clear direction.\nSolid execution.",
      visualMeta: "Android · Web · Desktop",
    },
    intro: {
      label: "Who I help",
      title: "The same personal service for needs of every size.",
      body: "PK-Forensics is an agile one-person service. I can help when you need a focused application, a digital tool or a clear technical solution without a heavy project.",
      values: [
        ["01", "Individuals", "An idea can become a small application, a useful calculator or a digital helper for everyday life."],
        ["02", "Clubs and communities", "Lightweight tools can support communication, tracking, training or shared activities."],
        ["03", "Companies", "Focused applications and utilities can support a single process without a heavy system project."],
      ],
    },
    service: {
      label: "Service",
      title: "App development",
      lead: "A lightweight, manageable way to turn a focused idea into a useful digital solution.",
      description: "I build small mobile, web and desktop applications as well as practical analytics tools. Every assignment is scoped into a clear whole that one developer can deliver with care.",
      platforms: ["Android", "Lightweight web tools", "Desktop utilities", "Data and visualisation"],
      stages: [
        ["01", "Need", "We identify the small or focused problem that needs to be solved."],
        ["02", "Scope", "The essential features are selected and the work stays manageable."],
        ["03", "Implementation", "The solution is built in steps and validated in practical use."],
        ["04", "Delivery", "The finished tool is refined for the agreed use."],
      ],
      cta: "Tell me what you need",
      emailSubject: "Enquiry for PK-Forensics",
    },
    work: {
      label: "Selected projects",
      title: "Solutions for real situations.",
      body: "Project examples",
      open: "View project",
      all: "All projects",
    },
    cases: {
      label: "Forensics lab",
      title: "Data speaks when you make it visible.",
      body: "The ByBit Hack analysis shows how a complex transaction chain can be translated into an understandable visual form.",
      open: "View case",
    },
    cta: {
      label: "Have an idea?",
      title: "Let's make it work.",
      body: "Whether you are an individual, a club or a company, tell me about a small idea or focused need that calls for a practical solution.",
      button: "Contact me",
    },
    contactDialog: {
      label: "Contact",
      title: "Contact me",
      body: "Choose the email service you use. A new message will open with jarmo@pk-forensics.fi as the recipient.",
      subject: "Enquiry for PK-Forensics",
      gmail: "Open Gmail",
      outlook: "Open Outlook",
      copy: "Copy email address",
      copied: "Email address copied",
      close: "Close",
    },
    footer: {
      statement: "Personal, practical app development and digital forensics for everyone.",
      navigation: "Navigation",
      contact: "Contact",
      businessId: "Business ID 2937386-3",
      privacy: "Privacy policy",
      ytVidPrivacy: "YTVidCreator privacy",
      rights: "All rights reserved.",
    },
    privacy: {
      title: "Privacy policy",
      updated: "Updated 22 April 2025",
      intro: "PK-Forensics handles information provided through enquiries confidentially and only to the extent required for the service.",
      sections: [
        ["Data controller", "PK-Forensics, Business ID 2937386-3, Finland. Contact: jarmo@pk-forensics.fi, +358 50 327 9741."],
        ["Data collected", "Name and contact details, message contents, and information required for a possible client and billing relationship."],
        ["Purpose", "Responding to enquiries, providing services, preparing quotes and agreements, billing, bookkeeping and maintaining service security."],
        ["Retention", "Enquiry messages are retained for up to 30 days after the last contact unless a client relationship is formed. Bookkeeping records are retained as required by law."],
        ["Disclosure", "Information is not disclosed to third parties without consent or a legal obligation and is not transferred outside the EU/EEA."],
        ["Your rights", "You have the right to access, rectify or request deletion of your data, restrict or object to processing, and exercise your other rights under data protection law."],
      ],
      close: "Close",
    },
    detail: {
      back: "Back to projects",
      overview: "Overview",
      focus: "Project focus",
      gallery: "Project views",
      viewGraph: "Open interactive 3D visualisation",
      store: "View on Google Play",
      next: "Next project",
      notFound: "Project not found",
      notFoundBody: "The project page you are looking for does not exist.",
      home: "Return home",
    },
  },
};

const playStoreUrl = "https://play.google.com/store/apps/details?id=com.jarmo.ballisticsai&pcampaignid=web_share";

export const projects = [
  {
    slug: "alpha-ballistics",
    type: "app",
    image: "/alpha.jpg",
    cardImage: "/alpha_ballistics/showcase.png",
    gallery: [
      "/alpha_ballistics/showcase.png",
      "/alpha_ballistics/rifles.jpg",
      "/alpha_ballistics/aiming.jpg",
      "/alpha_ballistics/table.jpg",
    ],
    externalUrl: playStoreUrl,
    content: {
      fi: {
        category: "Android-sovellus",
        title: "Alpha Ballistics",
        cardTitle: "Älykäs ballistiikkalaskuri",
        summary: "Android käyttöjärjestelmälle luotu uudenlainen ballistiikkalaskenta-sovellus metsästäjille, urheiluampujille (Practical / SRA) sekä tarkka-ammunnan harrastajille. Sovelluksen suunnittelussa ja testaamisessa on ollut mukana eri lajien ammattilaisia.",
        intro: "Alpha Ballistics kokoaa ballistisen laskennan ja kentällä tarvittavat tiedot yhteen mobiilikäyttöön suunniteltuun kokemukseen.",
        sections: [
          ["Haaste", "Ballistinen laskenta sisältää paljon muuttujia, mutta käyttäjän on saatava olennainen tieto nopeasti ja luotettavasti myös kenttäolosuhteissa."],
          ["Ratkaisu", "Sovellus yhdistää ase- ja patruunakohtaiset asetukset, käytännön laskennan ja selkeän etäisyysnäkymän yhdeksi johdonmukaiseksi Android-kokonaisuudeksi."],
        ],
        facts: [["Alusta", "Android"], ["Tila", "Julkaistu"], ["Fokus", "Ballistiikka · UX"]],
        imageAlts: [
          "Alpha Ballistics -esittelykuva",
          "Alpha Ballistics -sovelluksen asevalikko",
          "Alpha Ballistics -sovelluksen tähtäysnäkymä",
          "Alpha Ballistics -sovelluksen ballistiikkataulukko",
        ],
      },
      en: {
        category: "Android application",
        title: "Alpha Ballistics",
        cardTitle: "Smart ballistics calculator",
        summary: "An innovative ballistics calculation application developed for the Android operating system for hunters, sport shooters (Practical / SRA) and precision shooting enthusiasts. Professionals from different shooting disciplines have been involved in the design and testing of the application.",
        intro: "Alpha Ballistics brings ballistic calculations and essential field information into one mobile-first experience.",
        sections: [
          ["Challenge", "Ballistic calculations involve many variables, yet the user needs the essential result quickly and reliably in field conditions."],
          ["Solution", "The app combines rifle and cartridge profiles, practical calculations and a clear distance view in one coherent Android product."],
        ],
        facts: [["Platform", "Android"], ["Status", "Published"], ["Focus", "Ballistics · UX"]],
        imageAlts: [
          "Alpha Ballistics showcase",
          "Alpha Ballistics rifle menu",
          "Alpha Ballistics aiming view",
          "Alpha Ballistics ballistics table",
        ],
      },
    },
  },
  {
    slug: "pelastaja",
    type: "app",
    image: "/pelastaja.jpg",
    gallery: [],
    content: {
      fi: {
        category: "Offline-teknologia",
        title: "Pelastaja",
        cardTitle: "Bluetooth-hätäpaikannus ilman verkkoa",
        summary: "Mobiilisovellus hätäsignaalin lähettämiseen ja etsimiseen Bluetooth-yhteydellä ilman verkkoyhteyttä.",
        intro: "Pelastaja hyödyntää pitkän kantaman Bluetooth-paikannusta hätätilanteissa ja toimii ilman verkkoyhteyttä. Ratkaisua on testattu vaihtelevissa olosuhteissa: avoimessa maastossa havaintoetäisyys on yltänyt jopa 500 metriin ja metsäisessä maastossa jopa 200 metriin. Sovelluksen kehitys ja kenttätestaus jatkuvat.",
        sections: [
          ["Haaste", "Avun paikantaminen voi vaikeutua alueilla, joilla verkkoyhteys on heikko tai puuttuu kokonaan."],
          ["Ratkaisu", "Offline-first-mobiilikokemus hyödyntää Bluetoothia hätäsignaalin välittämiseen ja etsinnän tukemiseen lähietäisyydellä."],
        ],
        facts: [["Alusta", "Android"], ["Yhteys", "Bluetooth"], ["Fokus", "Offline · Turvallisuus"]],
        imageAlts: [],
      },
      en: {
        category: "Offline technology",
        title: "Pelastaja",
        cardTitle: "Bluetooth emergency location without a network",
        summary: "A mobile application for sending and locating distress signals over Bluetooth without a network connection.",
        intro: "Pelastaja uses long-range Bluetooth positioning in emergency situations and operates without a network connection. The solution has been tested in varying conditions: detection range has reached up to 500 metres in open terrain and up to 200 metres in forested terrain. Development and field testing continue.",
        sections: [
          ["Challenge", "Locating a person in distress can become difficult in areas where network coverage is weak or unavailable."],
          ["Solution", "An offline-first mobile experience uses Bluetooth to transmit a distress signal and support short-range search."],
        ],
        facts: [["Platform", "Android"], ["Connection", "Bluetooth"], ["Focus", "Offline · Safety"]],
        imageAlts: [],
      },
    },
  },
  {
    slug: "sectorx",
    type: "app",
    image: "/SectorX.png",
    gallery: [],
    content: {
      fi: {
        category: "Tilannekuva",
        title: "SectorX",
        cardTitle: "Nopea maastoanalyysi",
        summary: "Sovellus maaston, sektorien ja tilannekuvan nopeaan hahmottamiseen muuttuvissa tilanteissa.",
        intro: "SectorX on viranomais- ja sotilaskäyttöön kehitetty maastoanalyysisovellus mobiililaitteisiin. Kehitys alkoi käytännön tarpeesta kenttäolosuhteissa, josta se on jalostunut monipuoliseksi suunnittelutyökaluksi sekä nopeissa tilanteissa päätöksenteon tukena toimivaksi tuotteeksi. Sovellus on testaus- ja kehitysvaiheessa.",
        sections: [
          ["Haaste", "Maastoon liittyvä tieto on usein hajallaan ja päätöksiä on pystyttävä tekemään nopeasti."],
          ["Ratkaisu", "Visuaalinen mobiilityökalu jäsentää maaston, sektorit ja olennaisen tilannetiedon helposti hahmotettavaan muotoon."],
        ],
        facts: [["Tuote", "Mobiilisovellus"], ["Käyttö", "Kenttäolosuhteet"], ["Fokus", "Maasto · Tilannekuva"]],
        imageAlts: [],
      },
      en: {
        category: "Situational awareness",
        title: "SectorX",
        cardTitle: "Rapid terrain analysis",
        summary: "An application for quickly understanding terrain, sectors and the operational picture in changing situations.",
        intro: "SectorX is a mobile terrain analysis application developed for authority and military use. Development began from a practical need in field conditions and has evolved into a versatile planning tool and decision-support product for rapidly changing situations. The application is currently in testing and development.",
        sections: [
          ["Challenge", "Terrain information is often fragmented while decisions need to be made quickly."],
          ["Solution", "A visual mobile tool structures terrain, sectors and essential situational data into an easy-to-read view."],
        ],
        facts: [["Product", "Mobile app"], ["Use", "Field conditions"], ["Focus", "Terrain · Awareness"]],
        imageAlts: [],
      },
    },
  },
  {
    slug: "piilosta",
    type: "app",
    image: "/piilosta.jpg",
    gallery: [],
    content: {
      fi: {
        category: "Mobiilipeli",
        title: "Piilosta",
        cardTitle: "Piiloleikki puhelimilla",
        summary: "Mobiilisovellus, joka tuo klassisen piiloleikin puhelimiin ja jakaa pelaajat etsijöihin sekä piiloutujiin.",
        intro: "Piilosta rakentaa tutun ulkopelin ympärille digitaalisen kerroksen, joka ohjaa rooleja ja pelin etenemistä.",
        sections: [
          ["Haaste", "Fyysiseen ympäristöön sijoittuvan ryhmäpelin digitaalisen kokemuksen täytyy tukea leikkiä viemättä siltä huomiota."],
          ["Ratkaisu", "Selkeä mobiilikäyttöliittymä jakaa roolit, välittää pelin kannalta olennaisen tiedon ja pitää vuorovaikutuksen liikkeessä."],
        ],
        facts: [["Tuote", "Mobiilipeli"], ["Käyttö", "Moninpeli"], ["Fokus", "Paikka · Vuorovaikutus"]],
        imageAlts: [],
      },
      en: {
        category: "Mobile game",
        title: "Piilosta",
        cardTitle: "Hide and seek with phones",
        summary: "A mobile application that brings classic hide and seek to phones by assigning players as seekers and hiders.",
        intro: "Piilosta adds a digital layer around a familiar outdoor game, guiding roles and game progress.",
        sections: [
          ["Challenge", "A digital experience for a physical group game must support the play without distracting from it."],
          ["Solution", "A clear mobile interface assigns roles, communicates essential game information and keeps the interaction moving."],
        ],
        facts: [["Product", "Mobile game"], ["Use", "Multiplayer"], ["Focus", "Location · Interaction"]],
        imageAlts: [],
      },
    },
  },
  {
    slug: "bybit-case",
    type: "case",
    image: "/case1_images/ByBitHack.png",
    gallery: ["/case1_images/bybit1.PNG", "/case1_images/bybitLevel2_2D.png", "/case1_images/bybitLevel3_2D.png"],
    graphUrl: "/hackGraph.html",
    content: {
      fi: {
        category: "Lohkoketjuanalyysi",
        title: "ByBit-case",
        cardTitle: "1,4 miljardin dollarin kryptovarkaus",
        summary: "Visuaalinen tarkastelu siitä, miten varastettuja ETH-varoja hajautettiin lukuisiin lompakoihin jäljityksen vaikeuttamiseksi.",
        intro: "ByBit ilmoitti helmikuussa 2025 noin 1,4 miljardin dollarin ETH-varkaudesta. Tämä case keskittyy varojen liikkeen mallintamiseen tapahtuman jälkeen.",
        sections: [
          ["Ensimmäinen taso", "Varat siirrettiin hyökkääjän hallitsemaan lompakkoon ja hajautettiin tämän jälkeen kymmeniin osoitteisiin."],
          ["Syvempi analyysi", "Usean tason haku tekee lompakkoketjuista ja siirtojen kerrostumisesta näkyvän. 3D-mallinnus auttaa tutkimaan rakennetta interaktiivisesti."],
        ],
        facts: [["Verkko", "Ethereum"], ["Aineisto", "On-chain-siirrot"], ["Fokus", "Varojen jäljitys"]],
        imageAlts: ["Siirto hyökkääjän lompakkoon", "Toisen tason lompakkosiirrot", "Kolmannen tason hajautus"],
      },
      en: {
        category: "Blockchain analysis",
        title: "ByBit case",
        cardTitle: "A $1.4 billion crypto heist",
        summary: "A visual examination of how stolen ETH was dispersed across numerous wallets to make tracing more difficult.",
        intro: "In February 2025, ByBit reported the theft of approximately $1.4 billion in ETH. This case focuses on mapping the movement of funds after the event.",
        sections: [
          ["First layer", "Funds were transferred to an attacker-controlled wallet and then dispersed across dozens of addresses."],
          ["Deeper analysis", "Multi-level searches reveal wallet chains and layered transfers. A 3D model makes the structure available for interactive exploration."],
        ],
        facts: [["Network", "Ethereum"], ["Data", "On-chain transfers"], ["Focus", "Asset tracing"]],
        imageAlts: ["Transfer to the attacker wallet", "Second-level wallet transfers", "Third-level distribution"],
      },
    },
  },
];
